import * as React from "react";
const SvgFiRrPi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-Pi_svg__a)">
      <path
        fill="#062147"
        d="M24 20c0 2.206-1.794 4-4 4s-4-1.794-4-4V2H9v13.612c0 4.981-3.184 7.995-3.32 8.121a.995.995 0 0 1-1.413-.053 1 1 0 0 1 .053-1.413C4.344 22.244 7 19.695 7 15.612V2h-.5C2.126 2 2 5.585 2 5.994c0 .55-.444 1-.995 1.003H1a.997.997 0 0 1-1-.986c0-.102-.007-2.504 1.726-4.257C2.877.59 4.483 0 6.5 0H23a1 1 0 0 1 0 2h-5v18c0 1.103.897 2 2 2s2-.897 2-2a1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-Pi_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPi;
